const columns = [
    {
        dataField: 'origin_name',
        text: 'Origin Name',
        localizationSlug: 'ORIGIN_NAME',
    },
    {
        dataField: 'origin_location',
        text: 'Origin Location',
        type: 'location',
        localizationSlug: 'ORIGIN_LOCATION',
    },
    {
        dataField: 'destination_name',
        text: 'Destination Name',
        localizationSlug: 'DESTINATION_NAME',
    },
    {
        dataField: 'destination_location',
        text: 'Destination Location',
        type: 'location',
        localizationSlug: 'DESTINATION_LOCATION',
    },
    {
        dataField: 'shipper',
        text: 'Shipper',
        type: 'customer',
        localizationSlug: 'SHIPPER',
    },
    {
        dataField: '',
        text: 'Actions',
        type: 'customActions',
        localizationSlug: 'ACTIONS',
    },
];
export default {
    columns,
};
